import { render, staticRenderFns } from "./CountByCate.vue?vue&type=template&id=1cff5e3c&lang=pug"
import script from "./CountByCate.vue?vue&type=script&lang=js"
export * from "./CountByCate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports